var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTmovLogoBranco(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 322,
    height: 67,
    viewBox: "0 0 322 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 24.8459L10.425 14.554C13.3749 11.6412 17.3767 10.0049 21.5486 10.0049H59.9984V24.7596L39.8161 24.7872V64.3207H24.8707V24.8111L0 24.8459Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M164.629 22.71C172.702 22.71 179.268 29.1934 179.268 37.1626C179.268 45.1317 172.702 51.6151 164.629 51.6151C156.557 51.6151 149.99 45.1317 149.99 37.1626C149.99 29.1934 156.557 22.71 164.629 22.71ZM164.629 7.54492C148.061 7.54492 134.63 20.8053 134.63 37.1626C134.63 53.5198 148.061 66.7802 164.629 66.7802C181.197 66.7802 194.629 53.5198 194.629 37.1626C194.629 20.8053 181.197 7.54492 164.629 7.54492Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M239.75 10.0049L245.63 15.8105L217.63 43.4538V10.0049H201.945V64.3207H211.114C215.286 64.3207 219.288 62.6843 222.238 59.771L256.198 26.2439L262.079 32.0495V10.0049H239.75Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.3141 24.8674L107.761 14.5542C110.711 11.6413 114.712 10.005 118.885 10.005H127.314V64.3208H112.368V31.0796L97.3141 45.9421L82.2601 31.0796V64.3208H67.3147V10.005H75.7438C79.9161 10.005 83.9175 11.6413 86.8679 14.5542L97.3141 24.8674Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M283.361 24.32C282.131 24.98 280.901 25.22 279.581 25.22C275.561 25.22 272.771 22.43 272.771 18.5C272.771 14.51 275.561 11.78 279.641 11.78C281.771 11.78 283.541 12.53 285.071 14.15L288.191 11.27C286.151 8.9 283.091 7.64 279.401 7.64C272.711 7.64 267.851 12.17 267.851 18.5C267.851 24.83 272.711 29.36 279.311 29.36C282.311 29.36 285.491 28.43 287.801 26.69V18.17H283.361V24.32ZM313.915 29L309.205 22.25C311.935 21.08 313.525 18.77 313.525 15.62C313.525 10.91 310.015 8 304.405 8H295.315V29H300.175V23.15H304.405H304.645L308.695 29H313.915ZM308.605 15.62C308.605 17.9 307.105 19.28 304.135 19.28H300.175V11.96H304.135C307.105 11.96 308.605 13.31 308.605 15.62Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 262.158,
    height: 59.5813,
    fill: "white",
    transform: "translate(0 7.21936)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTmovLogoBranco);
export default __webpack_public_path__ + "static/media/tmov-logo-branco.5796b01b1f02e52347471c32ceed755d.svg";
export { ForwardRef as ReactComponent };